import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { login } from "@/redux/services/authApi";

const initialState = {
	user: localStorage.getItem("user")
		? JSON.parse(localStorage.getItem("user"))
		: null,
	token: localStorage.getItem("token") || null,
	error: null,
	isSuccess: false,
	isLoading: false,
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		logout: (state) => {
			state.user = null;
			state.token = null;
			localStorage.clear();
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(login.pending, (state) => {
				state.isLoading = true;
				state.isSuccess = false;
				state.error = null;
				localStorage.clear();
			})
			.addCase(login.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.token = action.payload;
				const decodedToken = jwtDecode(state.token);
				state.user = decodedToken;
				localStorage.setItem("token", state.token);
				localStorage.setItem("user", JSON.stringify(state.user));
			})
			.addCase(login.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.error = action.error;
				localStorage.clear();
			});
	},
});

export const { logout } = authSlice.actions;

export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectIsSuccess = (state) => state.auth.isSuccess;
export const selectError = (state) => state.auth.error;

export default authSlice.reducer;
